<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-layout wrap>
        <v-flex xs12 sm12 md12>
          <p style="font-size:18px">
            <b
              ><u> تقرير مرتبات الموظفين لشهر {{ month }} لعام {{ year }}</u>
            </b>
          </p>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <br />
          <br />
          <br />

          <v-flex v-if="fatworas.length > 0" xs12 sm6 md4
            ><b> جميع المرتبات : </b> {{ allsalaries }}</v-flex
          >
          <v-flex v-if="fatworas.length > 0" xs12 sm6 md4
            ><b> جميع الحوافز : </b> {{ hafezes }}</v-flex
          >
          <v-flex v-if="fatworas.length > 0" xs12 sm6 md4
            ><b> جميع السلف : </b> {{ solfas }}</v-flex
          >
          <v-flex v-if="fatworas.length > 0" xs12 sm6 md4
            ><b> جميع البدلات : </b> {{ badalates }}</v-flex
          >
          <v-flex v-if="fatworas.length > 0" xs12 sm6 md4
            ><b> جميع الخصومات : </b> {{ khasms }}</v-flex
          >
          <v-flex v-if="fatworas.length > 0" xs12 sm6 md4
            ><b> المجموع الكلي : </b> {{ total }}</v-flex
          >

          <v-flex xs12 sm12 md12>
            <v-btn color="orange" @click="get_table"
              >أختر الشهر ثم اضغط لمعرفة تفاصيل المرتبات والمحصلة
            </v-btn>
          </v-flex>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-flex xs12 sm12 md12>
            <v-date-picker
              v-model="picker"
              landscape
              type="month"
              color="green lighten-1"
            ></v-date-picker>
          </v-flex>
        </v-flex>
      </v-layout>

      <v-data-table
        :headers="headers"
        :items="fatworas"
        class="elevation-1"
        v-if="fatworas.length > 0"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.employer.code }}</td>
          <td>{{ props.item.employer.name }}</td>
          <td>
            {{
              props.item.employer && props.item.employer.job
                ? props.item.employer.job.name
                : ""
            }}
          </td>
          <td><p v-html="props.item.salary_before"></p></td>
          <td><p v-html="props.item.hafez"></p></td>
          <td><p v-html="props.item.badalat"></p></td>
          <td><p v-html="props.item.khasm"></p></td>
          <td><p v-html="props.item.solfa"></p></td>
          <td>{{ props.item.salary_after }}</td>
          <td><p v-html="props.item.notes"></p></td>
        </template>
      </v-data-table>
      <div v-else>لا يوجد فواتير</div>
    </v-container>
  </div>
</template>

<script>
import {
  items,
  branches,
  employers,
  khazna_fatworas,
  EmployerSalaryReport
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [11400, 11800],
    date_from: new Date().toISOString().substr(0, 10),
    date_to: new Date().toISOString().substr(0, 10),
    picker: new Date().toISOString().substr(0, 7),
    month: "",
    year: "",
    menu_from: false,
    modal_from: false,
    menu_to: false,
    modal_to: false,
    menu2: false,
    detail_dialog: false,
    add_dialog: false,
    edit_dialog: false,
    vacancy_types: [
      { id: 1, name: "مرض" },
      { id: 2, name: "اعتيادي" },
      { id: 3, name: "عارضة" }
    ],
    headers: [
      {
        text: " كود الموظف",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " اسم الموظف",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: " الوظيفة",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " المرتب ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "الحوافز ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " البدلات ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "الخصم ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "السلفة ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "صافي المرتب ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "الملاحظات ",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],
    active: "",
    select_employer_agaza: { id: "" },
    select_employer_absence: { id: "" },
    select_vacancy: { id: "" },
    search: "",
    comment: "",
    loading: true,
    agaza: "",
    absance: "",
    badalat: "",
    solfa: "",
    is_agaza: false,
    is_absence: false,
    is_badalat: false,
    is_solfa: false,
    khazina_fatworas: [],
    items: [],
    employers: [],
    fatworas: [],
    branches: [],
    all_client_fatworas: [],
    all_client_sadads: [],
    theKhazna: {},
    item_detail: {},
    all_of_total: 0,
    count_of_count: 0,
    madionia_sabqa_of_madionia: "",
    madionia_sabqa: "",
    allsalaries: "",
    hafezes: "",
    solfas: "",
    badalates: "",
    khasms: "",
    total: ""
  }),

  computed: {
    mycode() {
      if (this.khazina_fatworas.length > 0) {
        return (this.code =
          parseInt(
            this.khazina_fatworas[this.khazina_fatworas.length - 1].code
          ) + 1);
      } else {
        return (this.code = 1000);
      }
    },
    omola_percentage() {
      return function(total, omola) {
        return (parseFloat(total) * parseFloat(omola)) / 100;
      };
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.initialize();
  },

  methods: {
    initialize() {
      branches().then(response => {
        this.branches = response.data;
        this.loading = false;
      });

      khazna_fatworas().then(response => {
        this.khazina_fatworas = response.data;
      });

      this.month = this.picker.substr(5, 2);
      this.year = this.picker.substr(0, 4);
      var frmData = new FormData();
      frmData.append("month", this.month);
      frmData.append("year", this.year);
      EmployerSalaryReport(frmData).then(response => {
        this.fatworas = response.data.salaries;
        this.allsalaries = response.data.allsalaries;
        this.hafezes = response.data.hafezes;
        this.solfas = response.data.solfas;
        this.badalates = response.data.badalates;
        this.khasms = response.data.khasms;
        this.total = response.data.total;
      });
      employers().then(response => {
        this.employers = response.data;
      });

      items().then(response => {
        this.items = response.data;
      });
    },

    //   setTimeout(() => {
    //     this.editedItem = Object.assign({}, this.defaultItem)
    //     this.editedIndex = -1
    //   }, 300)
    get_table() {
      this.month = this.picker.substr(5, 2);
      this.year = this.picker.substr(0, 4);
      var frmData = new FormData();
      frmData.append("month", this.month);
      frmData.append("year", this.year);
      EmployerSalaryReport(frmData).then(response => {
        this.fatworas = response.data.salaries;
        this.allsalaries = response.data.allsalaries;
        this.hafezes = response.data.hafezes;
        this.solfas = response.data.solfas;
        this.badalates = response.data.badalates;
        this.khasms = response.data.khasms;
        this.total = response.data.total;
      });
    }
  }
};
</script>

<style scoped>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
.v-date-picker-table--month td {
  height: 35px;
}
.v-picker__body {
  height: 196px;
}
.v-table__overflow {
  width: 1000px;
  margin-right: -85px;
}
</style>
